
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Contactez-nous!</div>
Vivez-vous en zone de danger ou avez-vous connaissance d’un bâtiment particulièrement exposé? N’hésitez pas à contacter notre rédaction:<a href="mailto:cellule-enquete@tamedia.ch">cellule-enquete@tamedia.ch</a> gerne entgegen.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;